import React from "react";

import styles from "../navigation.module.scss";
import { menuLinkHREF } from "./auth-authenticated";
import { dropdownItems } from "./auth-authenticated-dropdown-items";
import { AuthUnauthenticated } from "./auth-unauthenticated";

export { menuLinkHREF, dropdownItems };
export { getBranchPortalURL, getPortalURL } from "./portalLinks";

export const Auth: React.FC = () => {
    return (
        <div className={styles.authDropdownMenuButtonContainer}>
            <AuthUnauthenticated />
        </div>
    );
};
